// extracted by mini-css-extract-plugin
export default {"skeuomorph-button-container":"SkeuomorphButton_skeuomorph-button-container__EaG0G","skeuomorph-button":"SkeuomorphButton_skeuomorph-button__714iy"};